import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vadiun/react-components';
import { useSuperMutation, useSuperQuery } from '@vadiun/react-hooks-legacy';
import useBiller from 'app/biller/services/useBiller';
import PageHeader from 'layout/components/PageHeader';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import PageContainer from '../../../layout/components/PageContainer';
import { useBusinessUnit } from '../../business/services/useBusinessUnit';
import useVehiculo from '../../vehiculos/services/VehiculoService';
import ChoferCreate from '../components/ChoferCreate';
import ChoferTable from '../components/ChoferTables/ChoferTable';
import {
  ChoferCreateFormSchema,
  choferCreateFormSchemaToModel,
} from '../models/ChoferFormSchema';
import useChoferes from '../services/ChoferService';
import { useChofer } from '../hooks/useChofer';
import { createTableScrollHandler } from 'utils/tableUtils';
import { VisiblePages } from '../models/choferPages';
import { ChoferModelSinTurno } from '../models/Chofer';

const ChoferCrudPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const ChoferService = useChoferes();
  const VehiculoService = useVehiculo();
  const ProveedorService = useBiller();
  const BusinessUnitService = useBusinessUnit();
  const [createdChofer, setCreatedChofer] = useState<ChoferModelSinTurno>(
    {} as ChoferModelSinTurno
  );
  const { drivers, filters, loading, onChangeFilters, onLoadDrivers } =
    useChofer();

  const searchRef = useRef<{ getSearch: () => string | null }>(null);

  useEffect(() => {
    onLoadDrivers(searchRef?.current?.getSearch() ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const { data: vehiculos } = useSuperQuery(
    VehiculoService.getVehiculosWithDeleted,
    {
      showSpinner: true
    }
  );

  const { data: proveedores } = useSuperQuery(ProveedorService.getBillers, {
    showSpinner: true
  });

  const { data: businessUnit } = useSuperQuery(
    BusinessUnitService.getBusinessUnit,
    {
      showSpinner: true
    }
  );

  const addMutation = useSuperMutation(ChoferService.addChofer, {
    onMutationFinish(state, arg) {
      if(state.data) {
      setCreatedChofer(state.data);}
    },
    messages: {
      success: {
        message: 'El Chofer fue creado con exito'
      }
    }
  });

  const [visiblePage, setVisiblePage] = useState<VisiblePages>(VisiblePages.TABLE);

  async function create(choferFormValues: ChoferCreateFormSchema, reset) {
    const chofer = choferCreateFormSchemaToModel(choferFormValues);
    await addMutation.mutate(chofer);
    reset();
    onLoadDrivers();
  }

  useEffect(() => {
    if (visiblePage === 'table') {
      setCreatedChofer({} as ChoferModelSinTurno);
    }
  }, [visiblePage]);
  return (
    <div ref={tableRef}>
      <PageHeader
        area="Operaciones - G.D.F."
        title="Chofer"
        subArea={
          visiblePage === 'table'
            ? 'Listado de Choferes'
            : visiblePage === 'create'
            ? 'Nuevo Chofer'
            : 'Perfil Chofer'
        }
        toolbar={
          visiblePage === 'table' ? (
            <Button onClick={() => setVisiblePage(VisiblePages.CREATE)} variant="light">
              Crear Chofer
            </Button>
          ) : visiblePage === 'create' ? (
            <Button onClick={() => setVisiblePage(VisiblePages.TABLE)} variant="light">
              Volver
            </Button>
          ) : null
        }
      />
      <PageContainer>
        {visiblePage === 'table' && (
          <ChoferTable
            handlePageChange={createTableScrollHandler(tableRef)}
            loading={loading}
            filters={filters}
            choferes={drivers || {total: 0, data: []}}
            onLoadDrivers={onLoadDrivers}
            onChangeFilters={onChangeFilters}
            searchRef={searchRef}
            onChoferModifyButton={(id) => (
              <Link
                to={'/main/operations/gdf/drivers/' + id}
                className="text-xs text-gray-400 hover:underline"
              >
                <FontAwesomeIcon
                  size="2x"
                  color="dodgerblue"
                  icon={faPencilAlt}
                />
              </Link>
            )}
          />
        )}

        {(visiblePage !== 'table'  )&& (
          <ChoferCreate
            vehiculos={vehiculos!}
            proveedores={proveedores!}
            businessUnit={businessUnit!}
            create={create}
            createdChofer={createdChofer}
            setVisiblePage={setVisiblePage}
          />
        )}
      </PageContainer>
    </div>
  );
};

export default ChoferCrudPage;
